import _extends from "@babel/runtime/helpers/extends";
export { getFinalStyle };
function getFinalStyle(_ref) {
  let isNewInfoElements = _ref.isNewInfoElements,
    shouldControlHorizontalAlignment = _ref.shouldControlHorizontalAlignment,
    style = _ref.style,
    horizontalAlignment = _ref.horizontalAlignment,
    paddingBottom = _ref.paddingBottom,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingLeft = _ref.paddingLeft;
  const newInfoStyle = _extends({}, style, {
    // paddingBottom: `${paddingBottom}px`,
    // paddingTop: `${paddingTop}px`,
    // paddingRight: `${paddingRight}px`,
    // paddingLeft: `${paddingLeft}px`,
    textAlign: horizontalAlignment,
    justifyContent: horizontalAlignment
  });
  if (shouldControlHorizontalAlignment === false) {
    delete newInfoStyle.textAlign;
  }
  return isNewInfoElements ? newInfoStyle : style || {};
}
//# sourceMappingURL=sharedBetweenInfoComponents.js.map